import * as $ajax from './_ajax'
import * as $helpers from './_helpers'
import * as $modal from './_modal'
import * as $msg from './_msg'

export interface IInitOptions {
    pageName: string
    pagePrefix: string
    id: string
}

var options: IInitOptions

export function init($options: any): void {
    options = $options

    console.log('init')

    elem('cb').each((_, cb) => {
        $(cb).on('click', () => {
            setTimeout(() => {
                const accountId = $(cb).attr('data-id')
                const chk = $(cb).is(':checked')

                console.log('spara ' + accountId + ' checked ' + chk)

                $ajax.post({
                    loadingText: 'Sparar...',
                    url: '/Account/AccountDepartmentsSaveDepartment',
                    data: {
                        departmentId: options.id,
                        accountId: accountId,
                        isChecked: chk,
                    },
                    success: function (res: any) {
                        if (!res.Ok) $msg.showError(res.Message)
                    },
                })

                countChecked()
            }, 500)
        })
    })
}

function countChecked(): void {
    const checkedElems = elem('cb').filter(':checked').length
    console.log('checked: ' + checkedElems)
    $('.bcfla-pade-row-' + options.id + ' .bcfla-pade-icon-accounts').html(checkedElems.toString())
}

function elem(suffix: string): JQuery {
    return $('.' + options.pagePrefix + '-' + suffix)
}
